import React from 'react';
import { FileText, Shield, MessageSquare } from 'lucide-react';

const QUALITAET_PUNKTE = [
  {
    icon: FileText,
    title: 'Klare Dokumentation',
    text: 'Strukturierte Erfassung aller relevanten Schadenspositionen.'
  },
  {
    icon: Shield,
    title: 'Objektive Bewertung',
    text: 'Unabhängige Einschätzung ohne Interessenkonflikt.'
  },
  {
    icon: MessageSquare,
    title: 'Verständliche Kommunikation',
    text: 'Ohne Fachsprache, direkt nachvollziehbar.'
  }
];

export const QualitaetVertrauen = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Qualität
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Strukturiert, nachvollziehbar, unabhängig
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {QUALITAET_PUNKTE.map((punkt, index) => {
            const Icon = punkt.icon;
            return (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-3xl p-8 hover:border-brand-green/30 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-brand-green/10 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-brand-green/15">
                  <Icon className="w-8 h-8 text-brand-green" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center tracking-tight">{punkt.title}</h3>
                <p className="text-gray-600 leading-relaxed text-[15px] text-center">{punkt.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};